<template>
    <div class="list-metal">
        <div class="text-right mb-3">
            <b-button class="btn mr-2" size="sm" @click="showModal('modal-add-withdraw')" v-show="withdrawalMetal.length > 0">Add Withdraw</b-button>
            <b-button class="btn btn-info mr-1 btn-sm" @click="showFilter" v-if="role != 9">Filter</b-button>
        </div>
        <filter-table-deposit
            v-if="isShowFilter"
            @setDataFilter="setDataFilterToParent"
            :dataClient="dataClient"
            :dataContract="dataContract"
        ></filter-table-deposit>
        <table>
            <thead>
                <tr id="top">
                    <th scope="col" style="width: 70px">
                        <div v-if="role == 2"></div>
                        <div v-else>No</div>
                    </th>
                    <th scope="col">Serial Number</th>
                    <th scope="col">Year</th>
                    <th scope="col" style="width: 200px">owner</th>
                    <th scope="col" style="width: 120px">Withdrawal Date</th>
                    <th scope="col" style="width: 120px" v-if="typeWithdrawal == 'offexchange'">Deposit Due Date</th>
                    <th scope="col">Fineness</th>
                    <th scope="col">Hallmark</th>
                    <th scope="col">Denom (gr)</th>
                </tr>
            </thead>
            <tbody v-if="isLoadingData">
                <tr>
                    <td colspan="10">
                        <b-spinner></b-spinner>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(data, i) in metalData" :key="i" v-show="metalData.length != 0">
                    <td data-label="No">
                        <div v-if="role == 2">
                            <input type="checkbox" name="" id="" v-model="withdrawalMetal" :value="data.metal_id" @input="addMetalWithdraw(data.metal_id, $event)" />
                        </div>
                        <div v-else>
                            {{ (pageNumber - 1) * totalPerPage + (i + 1) }}
                        </div>
                    </td>
                    <td data-label="Serial Number">{{ data.serial_number }}</td>
                    <td data-label="Year">{{ data.year }}</td>
                    <td data-label="Owner">{{ data.owner }}</td>
                    <td data-label="Deposite Date">{{ data.metal_date | formatDate }}</td>
                    <td data-label="Deposite Due Date" v-if="typeWithdrawal == 'offexchange'">{{ data.due_date | formatDate }}</td>
                    <td data-label="Fineness">{{ data.fineness }}</td>
                    <td data-label="Hallmark">{{ data.hallmark }}</td>
                    <td data-label="Weight">{{ data.weight }}</td>
                </tr>
                <tr v-show="metalData.length == 0">
                    <td colspan="10">No Data Available in Table</td>
                </tr>
            </tbody>
        </table>
        <b-modal ref="modal-add-withdraw" title="Add Withdrawal">
            <form action="">
                <div class="form-group">
                    <label for="">Owner</label>
                    <select name="" id="" class="form-input" v-model="form.owner">
                        <option value="" selected disabled>Choose Owner</option>
                        <option v-for="(client, i) in dataClient" :value="client" :key="i">{{ client }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="">Permission IBOSS</label>
                    <select name="" id="" class="form-input" v-model="form.id_ijin">
                        <option value="" selected disabled>Choose Permission</option>
                        <option v-for="(permission, i) in dataPermission" :key="i" :value="permission.id_ijin" v-show="permission.idlayan == '009004'">
                            {{ permission.urailayan }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="">Permission Seri</label>
                    <select name="" id="" class="form-input" v-model="form.seri">
                        <option value="" selected disabled>Choose Seri</option>
                        <option v-for="(commodity, i) in commodityData" :key="i" :value="commodity.seri">
                            {{ commodity.seri }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="">Withdrawal Date</label>
                    <input type="date" class="form-input" v-model="form.withdrawal_date" :max="today" />
                </div>
                <div class="form-group">
                    <label for="">Description</label>
                    <input type="text" class="form-input" v-model="form.description" />
                </div>
            </form>
            <template #modal-footer>
                <div class="wrap-button">
                    <button class="btn mr-1" type="button" @click="hideModal('modal-add-withdraw')">Cancel</button>
                    <button class="btn btn-primary" type="button" @click="addWithdraw">
                        <b-spinner variant="light" small v-if="isLoading"></b-spinner>
                        <span v-else>Submit</span>
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import FilterTableDeposit from "../utility/filter/FilterTableDeposit.vue";
export default {
    components: { FilterTableDeposit },
    props: {
        metalData: Array,
        pageNumber: Number,
        totalPerPage: Number,
        dataContract: Array,
        dataClient: Array,
        isLoadingData: Boolean,
        totalData: Number,
        typeWithdrawal: {
            type: String,
            default: "onexchange",
        },
    },
    data() {
        return {
            withdrawalMetal: [],
            commodityData: [],
            role: sessionStorage.getItem("role"),
            isLoading: false,
            isShowFilter: false,
            clientSelected: {
                id: "",
                owner: "",
            },
            form: {
                info: "",
                owner: "",
                id_ijin: "",
                seri: 0,
                withdrawal_date: "",
                metal_info: [],
                description: "",
            },
            today: "",
            activity: "deposit",
            owner: "",
            startDate: "",
            endDate: "",
            serial_number: "",
            hallmark: "",
            status: "",
            date_type: "",
            perPage: 10,
            currentPage: 1,
            contract_id: "",
            dataPermission: [],
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        // axios.get("/v2/clearing/admin/abx/get/list_depositor?type=offexchange").then((res) => {
        //     this.dataClient = res.data.data.body;
        // });
        axios.get("/v2/clearing/admin/abx/get/list_ijin").then((res) => {
            this.dataPermission = res.data.data.body;
        });
    },
    watch: {
        "form.id_ijin"() {
            if (this.form.id_ijin != "") {
                this.ibossID(this.form.id_ijin);
            }
        },
    },
    methods: {
        ibossID(event) {
            axios.get("/v2/clearing/admin/abx/get/detail_ijin/" + event).then((res) => {
                this.commodityData = res.data.data.komoditas;
            });
        },
        addMetalWithdraw(metal_id, event) {
            if (event.target.checked) {
                this.withdrawalMetal.push(metal_id);
            } else {
                this.withdrawalMetal.splice(this.withdrawalMetal.indexOf(metal_id), 1);
            }
        },
        showModal(modalRef) {
            this.$refs[modalRef].show();
        },
        hideModal(modalRef) {
            this.$refs[modalRef].hide();
        },
        showFilter() {
            this.isShowFilter = !this.isShowFilter;
            this.$emit("setShowFilter", this.isShowFilter);
        },
        setDataFilterToParent(event) {
            this.$emit("setFilterTable", event);
        },
        addWithdraw() {
            this.form.metal_info = this.withdrawalMetal;
            this.isLoading = true;
            this.$store.dispatch("getLocation").then((resGeo) => {
                if (resGeo.cityData[0]) {
                    this.form.info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    this.form.info = JSON.stringify(data);
                }
                axios
                    .post("/v2/clearing/admin/abx/withdrawal", this.form)
                    .then((res) => {
                        if (!res.data.iserror) {
                            this.$toast.success("Add Withdrawal Success");
                            this.isLoading = false;
                            setTimeout(() => {
                                location.reload();
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        let msg;
                        if (error.response.data.data.err_message) {
                            msg = error.response.data.data.err_message;
                        } else {
                            msg = error.response.data.message;
                        }
                        this.isLoading = false;
                        this.$toast.error(msg);
                    });
            });
        },
    },
};
</script>

<style scoped>
.form-group label {
    width: 30%;
}

.form-input {
    width: 70%;
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 5px 0.5rem;
    font-size: 13px;
}
</style>
